import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grow from '@material-ui/core/Grow'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import MenuIcon from '@material-ui/icons/Menu'
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PAGES from '../pages'
import apiRest from '../services/apiRest'
import { StoreState } from '../store'
import { DrawerActionTypes } from '../store/drawer/drawerTypes'
import { logout } from '../store/session/sessionActions'
import { addSnackbar } from '../store/snacks/snacksActions'

const drawerWidth = 250

const useStyles = makeStyles((theme) => ({
  search: {
    margin: '0',
  },
  blankSpace: {
    flexGrow: 1,
  },
  userButton: {
    color: '#fff',
    textTransform: 'none',
    fontWeight: 'lighter',
    marginRight: theme.spacing(1),
  },
  iconOff: {
    display: 'none',
    textTransform: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  appBar: {
    [theme.breakpoints.up('lg')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
}))

export default function Navbar() {
  const classes = useStyles()
  const { pathName, userName } = useSelector(
    ({ sessionState, router }: StoreState) => ({
      pathName: router.location.pathname,
      userName: sessionState.user?.name || '',
    })
  )

  const dispatch = useDispatch()
  const currentPage = PAGES.find(
    (page) => page.path.split('/')[1] === pathName.split('/')[1]
  )
  const [isOpenUserMenu, setOpenUserMenu] = useState(false)
  const refAnchorUserMenu = useRef<any>(null)

  const [isOpenModalPassword, setOpenModalPassword] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const changePassword = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      dispatch(addSnackbar('Preencha todos os campos'))
      return
    }
    if (newPassword !== confirmPassword) {
      dispatch(addSnackbar('As senhas não conferem. Verifique.'))
      return
    }
    try {
      const res = await apiRest({
        method: 'patch',
        url: '/users/password',
        data: { oldPassword, newPassword },
        validateStatus: (status) => status !== 500,
      })
      if (res.status === 401) {
        dispatch(
          addSnackbar('Senha atual incorreta. Verifique e tente novamente', {
            variant: 'error',
          })
        )
      } else if (res.status === 200) {
        dispatch(
          addSnackbar('Sua senha foi alterada com sucesso', {
            variant: 'success',
          })
        )
        setOpenModalPassword(false)
        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
      }
    } catch (e) {
      dispatch(
        addSnackbar('Houve um problema. Tente mais tarde', { variant: 'error' })
      )
    }
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={() =>
            dispatch({ type: DrawerActionTypes.OPEN_MOBILE_DRAWER })
          }
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>

        <Typography
          noWrap
          variant="h6"
          color="inherit"
          children={currentPage ? currentPage.title : ''}
        />

        <div className={classes.blankSpace} />

        <Button
          color="inherit"
          ref={refAnchorUserMenu}
          onClick={() => setOpenUserMenu(true)}
        >
          <AccountCircleIcon />
          <Hidden smDown>
            <Box marginX={1}>{userName}</Box>
          </Hidden>
          <ArrowDropDownIcon />
        </Button>
      </Toolbar>

      <Popper
        transition
        disablePortal
        open={isOpenUserMenu}
        anchorEl={refAnchorUserMenu.current}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper id="menu-list-grow">
              <ClickAwayListener onClickAway={() => setOpenUserMenu(false)}>
                <MenuList>
                  <MenuItem
                    onClick={() => setOpenModalPassword(true)}
                    children="Alterar minha senha"
                  />
                  <MenuItem
                    onClick={() => {
                      dispatch(logout())
                    }}
                    children="Sair"
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <Dialog
        open={isOpenModalPassword}
        onClose={() => setOpenModalPassword(false)}
      >
        <DialogTitle>Alterar senha</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Senha atual"
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <TextField
            fullWidth
            label="Nova senha"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            fullWidth
            label="Confirme a nova senha"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalPassword(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={changePassword} color="primary">
            Alterar senha
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  )
}
